var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.538,
    height: 11.538,
    viewBox: "0 0 11.538 11.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.972,8.408H3.126C.9,8.408.491,7.375.386,6.37L.025,2.519A2.28,2.28,0,0,1,.458.712,2.809,2.809,0,0,1,2.645,0H7.453A2.813,2.813,0,0,1,9.64.712a2.287,2.287,0,0,1,.433,1.812L9.712,6.365C9.607,7.375,9.193,8.408,6.972,8.408ZM2.645.716a2.2,2.2,0,0,0-1.654.476,1.556,1.556,0,0,0-.25,1.255L1.1,6.3c.082.76.288,1.389,2.024,1.389H6.972C8.7,7.687,8.914,7.057,9,6.293l.361-3.841a1.563,1.563,0,0,0-.25-1.26A2.2,2.2,0,0,0,7.453.716Z",
    transform: "translate(0.72 2.529)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.207,2.644a.363.363,0,0,1-.361-.361V1.9c0-.856,0-1.178-1.178-1.178H1.9C.721.721.721,1.043.721,1.9v.385a.363.363,0,0,1-.361.361A.363.363,0,0,1,0,2.284V1.9C0,1.053,0,0,1.9,0h.769c1.9,0,1.9,1.053,1.9,1.9v.385A.363.363,0,0,1,4.207,2.644Z",
    transform: "translate(3.485 0.601)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.322,2.644C0,2.644,0,1.827,0,1.336v-.5C0,.163.163,0,.841,0H1.8c.678,0,.841.163.841.841v.481C2.644,1.822,2.644,2.644,1.322,2.644ZM.721.721v.615c0,.5,0,.587.6.587s.6-.077.6-.591V.721H.721Z",
    transform: "translate(4.447 5.408)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.358,2.176A.358.358,0,0,1,0,1.859a.362.362,0,0,1,.312-.4A7.584,7.584,0,0,0,3.825.07a.358.358,0,0,1,.5.082.362.362,0,0,1-.082.5A8.348,8.348,0,0,1,.4,2.176Z",
    transform: "translate(6.372 4.925)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.912,2.047H3.869A8.246,8.246,0,0,1,.157.657a.36.36,0,1,1,.4-.6A7.573,7.573,0,0,0,3.946,1.33a.361.361,0,0,1,.317.4A.347.347,0,0,1,3.912,2.047Z",
    transform: "translate(0.895 5.059)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.538V11.538H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.b738c7dcd7f09cfdb7aac232373d2f0f.svg";
export { ForwardRef as ReactComponent };